module.exports = __webpack_public_path__ + "static/media/bg-big.993fac8e.png";